module.exports = __webpack_public_path__ + "img/gado.08b224fd.jpeg";